module.exports = __webpack_public_path__ + "img/home-delivery-date.b5da3bd0.jpg";